









































import { defineComponent, onMounted, reactive, toRefs, onBeforeUnmount } from '@vue/composition-api';
import { getShareCommonParams } from '@common/log';


export default defineComponent({
    components: {

    },

    props: {
        position: {
            type: String,
            required: true,
        },
        isPlaying: {
            type: Boolean,
            default: false,
        },
        isLiving: {
            type: Boolean,
            default: false,
        },
        liveEndWhileLiving: {
            type: Boolean,
            default: false,
        },
    },

    setup(props, ctx) {

        const {
            initData: { kpn, query, liveInfo: {
                userInfo, liveStreamId, liveCoverUrl, liveOriginalSource, shareUserId, hlsPlayUls,
            }, lang: localLang, rtl: isRtl, shareUserInfo, kpnInfo, ASSETS },
            message: { livePageConf },
        } = ctx.root.$store.state;
        const logName = props.position === 'top' ? 'TOP_BANNER_CARD' : 'BOTTOM_BANNER_CARD';
        const inNewLiveStyle = livePageConf.livePageReconsitutionExp;
        const shareLogPara = getShareCommonParams(query);
        const logParam = {
            author_id: userInfo.userId,
            live_stream_id: liveStreamId,
            share_user_id: shareUserId,
            ...shareLogPara,
        };
        const liveIcon = 'https://cdn-static.kwai.net/kos/s101/nlav11312/share_img/icon-live.png'

        const computedBannerBgPic = () => {
            if (!props.isPlaying && props.isLiving) {
                return `center / cover url(${liveIcon}) no-repeat,center / cover url(${!props.isPlaying && props.isLiving ? userInfo.userHead : shareUserInfo.headurl}) no-repeat`
            }
            return `center / cover url(${!props.isPlaying && props.isLiving ? userInfo.userHead : shareUserInfo.headurl}) no-repeat`;
        }
        const computedName = () => {
            if (props.position === 'top' || props.isPlaying) {
                return shareUserInfo.user_name;
            }
            return !props.isPlaying && props.isLiving ? userInfo.userName : `@ ${shareUserInfo.user_name}`;
        }

        const computedSideInfo = () => {
            if (!props.isLiving || props.position === 'top') {
                return livePageConf.liveTopBanner.bannerInviteText;
            }
            if (props.position === 'bottom') {
                return props.isPlaying ? livePageConf.liveTopBanner.bannerInviteText : `ID: ${userInfo.userSnackId}`;
            }
        }

        const computedBackgroundColor = () => {
            if (props.position === 'top') {
                return '#202020';
            } else if (props.position === 'bottom') {
                return props.isLiving || props.isPlaying ? 'rgba(0, 0, 0, 0.32)' : '#202020';
            }

            // 兜底
            return '#202020';
        };

        const pressUserOrFollowHandler = (source) => {
            ctx.emit('jumpAppOrDown', source);
        }

        const bottomButtonText = () => {
            if (props.position === 'bottom') {
                return props.isPlaying ? localLang['share_photo_checkitout'] : localLang['video-share.follow']
            } else if (props.position === 'top') {
                return localLang['video-share.open']
            }
            // 兜底
            return localLang['video-share.open'];
        }

        const state = reactive({

        });

        onMounted(() => {

        });

        return {
            ...toRefs(state),
            inNewLiveStyle,
            logParam,
            isRtl,
            shareUserInfo,
            userInfo,
            livePageConf,
            localLang,
            computedBackgroundColor,
            bottomButtonText,
            logName,
            pressUserOrFollowHandler,
            computedName,
            computedSideInfo,
            computedBannerBgPic,
        };
    },
});
